
  import { Component, Prop, Vue } from "vue-property-decorator";
  import UiButton from "@/components/button/ui-button.vue";

  @Component({
    components: {
      UiButton,
    },
  })
  export default class ResendInvitation extends Vue {
    @Prop({ type: Boolean, default: false }) readonly processing!: boolean;
  }
